import { render, staticRenderFns } from "./Restores.vue?vue&type=template&id=a2e00b8e"
import script from "./Restores.vue?vue&type=script&lang=js"
export * from "./Restores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports